import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiCardInfoComponent } from '@components/shared/ui-card-info/ui-card-info.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        MatIconModule,
    ],
    declarations: [
        UiCardInfoComponent,
    ],
    exports: [
        UiCardInfoComponent,
    ],
})
export class UiCardInfoModule { }
